import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import PIIRITMDisplay from "../../components/PIIReportRITMDisplay/PIIReportRITMDisplay";
import { checkPermission } from "services/sharedServices";
import { useAuth } from "context/AuthContext";

const PIIReportByRITM = () => {
  const { ticketNumber } = useParams();
  const [reportDisplay, setReportDisplay] = useState(false);
  const { isLoaded, roles, hasAnyPermission } = useAuth();

  useEffect(() => {
    localStorage.setItem("OBTPII", window.location.pathname);

    const fetchData = () => {
      if (!isLoaded) return;

      if (roles.length === 0) {
        window.location.href = "/";
        return;
      }

      if (
        hasAnyPermission(["PII_Group_FULL", "PII_Group_Med", "ISU_PRV_Access"])
      ) {
        setReportDisplay(true);
      } else {
        setReportDisplay(false);
        window.localStorage.removeItem("OBTPII");
      }
    };

    fetchData();
  }, [isLoaded, roles]);

  return (
    <>
      {reportDisplay ? (
        <PIIRITMDisplay ticketNumber={ticketNumber}></PIIRITMDisplay>
      ) : (
        <>Not eligible to access this page.</>
      )}
    </>
  );
};

export default PIIReportByRITM;
